module.exports = __webpack_public_path__ + "static/media/mastercard.55f7fa71.svg";